// Route-level error boundary per docs/ui/operator-ui-tds.md §11.3.
// Renders "Reload" + "Report issue" affordances; the latter copies operator URN + traceparent
// once those are wired (NEX-144 / NEX-147).

import { useTranslation } from 'react-i18next';
import type { FallbackProps } from 'react-error-boundary';
import { Button } from './ui/button';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';

export function RouteErrorFallback({ error, resetErrorBoundary }: FallbackProps) {
  const { t } = useTranslation('admin');
  return (
    <div className="flex min-h-screen items-center justify-center p-6">
      <Card className="max-w-md">
        <CardHeader>
          <CardTitle>{t('error.title')}</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <p className="text-sm text-muted-foreground">
            {error instanceof Error ? error.message : t('error.unexpected')}
          </p>
          <div className="flex gap-2">
            <Button onClick={resetErrorBoundary}>{t('error.reload')}</Button>
            <Button
              variant="outline"
              onClick={() => {
                void navigator.clipboard.writeText(
                  JSON.stringify(
                    {
                      message: error instanceof Error ? error.message : String(error),
                      stack: error instanceof Error ? error.stack : undefined,
                      url: window.location.href,
                      timestamp: new Date().toISOString(),
                    },
                    null,
                    2,
                  ),
                );
              }}
            >
              {t('error.copyDetails')}
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
